
/* v8 ignore start */
// Actions
import { createSlice } from '@reduxjs/toolkit';
export const name = 'zen/BulkEdition';
import moment from 'moment';
import { convertMomentToDatePickerTime } from 'helpers/timeFormat';

const widgetSettingsDefault ={
  title: {
    header:'Title',
    value:'',
    selected: false,
    componentType: 'text',
    visible:true,
  },
  sub_title:{
    header:'Subtitle',
    value:'',
    selected: false,
    componentType: 'text',
    visible:true,
  },
  widget_filter: {
    header:'Smart Filter',
    value:'',
    selected: false,
    doNotDisplay: false,
    componentType: 'smartfilter',
    visible:true,
  },
  dateRange_option:{
    header:'Date Range',
    value: {
      startDate: convertMomentToDatePickerTime(moment().subtract(4, 'day').startOf('day')),
      endDate: 'now'
    },
    selected: false,
    doNotDisplay: false,
    componentType: 'daterangepicker',
    visible:true,
  },
  candidate: {
    header:'Single Dataset Widgets',
    value:'',
    selected: false,
    componentType: 'select',
    visible:true,
  },
  candidates: {
    header:'Multi-Dataset Widgets',
    value: [],
    selected: false,
    includeAll: false,
    componentType: 'select-multi',
    visible:true,
  },
};
export const initialState = {
  isSaving: false,
  isOpen: false,
  nextDisabled: true,
  widgetSettings: widgetSettingsDefault,
  selectedColumns: [],
  isBulkEditionMode: false,
  selectedWidgets: [],
  sideBarSummary: []
};
let selectedWidgets;
const bulkEditWizardSlice = createSlice({
  name,
  initialState,
  reducers: {
    handleOpen: (state) => {
      state.sideBarSummary.push(`Widget Selected (${state.selectedWidgets.length})`);
      const uniqueWidgetTypeMap = new Map();

      state.selectedWidgets.forEach((widget) => {
        let cnt=1;
        if(uniqueWidgetTypeMap.has(widget.widget_type)) {
          cnt += uniqueWidgetTypeMap.get(widget.widget_type);
        }
        uniqueWidgetTypeMap.set(widget.widget_type, cnt);
      });

      const hideCols = {
        widget_filter: [],
        dateRange_option: [],
        candidate: [],
        candidates: [],
      };
      const { Views } = window;
      for(const [key, value] of uniqueWidgetTypeMap) {
        // eslint-disable-next-line no-negated-condition
        const widgetView = (Views && Views[key].prototype.defaults) || {};
        const widgetName = `${widgetView.title} ${widgetView.sub_title}`;
        const lengthDisp = value > 1? ` (${value})`:'';
        state.sideBarSummary.push(`${widgetName}${lengthDisp}`);
        hideCols.widget_filter.push(widgetView.has_filter_selector);
        hideCols.dateRange_option.push(widgetView.has_dateRange_selector);
        hideCols.candidate.push(widgetView.has_profile_selector);
        hideCols.candidates.push(widgetView.has_included_profiles);
      }
      state.widgetSettings.widget_filter.visible = hideCols.widget_filter.some((visible)=>visible);
      state.widgetSettings.dateRange_option.visible = hideCols.dateRange_option.some((visible)=>visible);
      state.widgetSettings.candidate.visible = hideCols.candidate.some((visible)=>visible);
      state.widgetSettings.candidates.visible = hideCols.candidates.some((visible)=>visible);
      state.isOpen=true;
    },
    handleClose: () => {
      return initialState;
    },
    setSetting: (state,{ payload }) => {
      if(payload.hasOwnProperty('property')) {
        state.widgetSettings[payload.name][payload.property] =!state.widgetSettings[payload.name][payload.property];
        if(payload.property === 'includeAll'){
          if(!state.widgetSettings[payload.name][payload.property]){
            state.widgetSettings[payload.name].value = '';
            return;
          }
          state.widgetSettings[payload.name].value = payload.value;
        }
        return;
      }
      state.widgetSettings[payload.name].value = payload.value;
      if(payload.hasOwnProperty('includeAll') && state.widgetSettings[payload.name].componentType === 'select-multi') {
        state.widgetSettings[payload.name].includeAll = payload.includeAll;
      }
    },
    setSelectedCols: (state,{payload}) => {
      state.widgetSettings[payload.name].selected = !state.widgetSettings[payload.name].selected;
      state.nextDisabled = Object.keys(state.widgetSettings)
        .map((colName) => state.widgetSettings[colName].selected)
        .every((selected) => selected === false);
    },
    exitBulkEditionMode: () => {
      return { ...initialState };
    },
    toggleBulkEditionMode: (state) => {
      state.isBulkEditionMode = !state.isBulkEditionMode;
      state.selectedWidgets =[];
    },
    selectWidget: (state, {payload}) => {
      selectedWidgets = [...state.selectedWidgets, payload];
      state.selectedWidgets = selectedWidgets;
    },
    unselectWidget: (state, {payload}) => {
      selectedWidgets = state.selectedWidgets.filter(
        (selected) => selected.id !== payload.id
      );
      state.selectedWidgets = selectedWidgets;
    },
    backButton: (state) => ({ ...state, activeIndex: 0 }),
    applySettings: () => {
      return;
    },
    handleSavingState: (state) => {
      state.isSaving = true;
    }
  }
});

const { actions, reducer } = bulkEditWizardSlice;
export default reducer;
export const {
  exitBulkEditionMode,
  handleClose,
  handleOpen,
  selectWidget,
  setSelectedCols,
  setSetting,
  toggleBulkEditionMode,
  unselectWidget,
  backButton,
  applySettings,
  handleSavingState
} = actions;
